import React from 'react';
import {View} from 'react-native';

import {MessageBanner} from '/component/base/MessageBanner/MessageBanner';
import {withTranslation} from '/provider/TranslationProvider';

import {useNetInfoProvider} from './NetInfoProvider.hook';
import {styles} from './NetInfoProvider.style';

interface NetInfoProviderProps {
  ts: (key: string, value: string) => any;
  isConnected: boolean;
  children: React.ReactNode;
}

const NetInfoProvider = ({
  ts = withTranslation.tsDefaultProp,
  isConnected = false,
  children = null,
}: NetInfoProviderProps) => {
  const {isVisible, onClose} = useNetInfoProvider({isConnected});

  return (
    <>
      {children}
      {!isConnected && isVisible ? (
        <View style={styles.messageBanner}>
          <MessageBanner
            bannerClose={onClose}
            alertLevel="error"
            message={ts(
              'message',
              'No network. Check your internet connection',
            )}
          />
        </View>
      ) : null}
    </>
  );
};

const NetInfoProviderWithTranslation =
  withTranslation('netInfoAlert')(NetInfoProvider);

export {NetInfoProviderWithTranslation as NetInfoProvider};
